var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { system, color } from "styled-system";
var linkTextHover = system({
    hoverColor: {
        property: "color",
        scale: "colors"
    }
});
export var Link = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-decoration: none;\n  cursor: pointer;\n  &:hover,\n  > div:hover {\n    text-decoration: underline;\n    ", "\n  }\n  ", "\n"], ["\n  text-decoration: none;\n  cursor: pointer;\n  &:hover,\n  > div:hover {\n    text-decoration: underline;\n    ", "\n  }\n  ", "\n"])), linkTextHover, color);
Link.defaultProps = {
    color: "link",
    hoverColor: "link"
};
var templateObject_1;
//# sourceMappingURL=Link.js.map